import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const ListSequent = ({ form, lang }) => {
    // const allItem = Form.useWatch('allItem', form) ?? [];
    const allItem = [
        {
            "groupId": "2a6fc2d73427491391328d0fe1d02948",
            "nameTh": "Barcode พ.ร.บ.",
            "nameEn": "Barcode พ.ร.บ.",
        },
        {
            "groupId": "c3b2f4379e864b5a86f9d9f0668fa1e0",
            "nameTh": "การศึกษา",
            "nameEn": "การศึกษา",
        },
        {
            "groupId": "fedfe1ff78924181be0f0056f19d0913",
            "nameTh": "ชื่อ, ชื่อกลาง, นามสกุล, นามแฝง ของผู้เอาประกันภัย ผู้ถือกรมธรรม์ประกันภัย และผู้รับประโยชน์",
            "nameEn": "ชื่อ, ชื่อกลาง, นามสกุล, นามแฝง ของผู้เอาประกันภัย ผู้ถือกรมธรรม์ประกันภัย และผู้รับประโยชน์",
        },
        {
            "groupId": "5d7398f9295a4a7b97388d29e1de2919",
            "nameTh": "ทะเบียนรถยนต์ / หมายเลขตัวถัง / รุ่นรถยนต์",
            "nameEn": "ทะเบียนรถยนต์ / หมายเลขตัวถัง / รุ่นรถยนต์",
        }
    ]
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragPersonalEnd = (result) => {
        // dropped outside the list
        console.log('result ',result)
        if (!result.destination) {
            return;
        }
        const newItems = reorder(
            allItem,
            result.source.index,
            result.destination.index
        );
        form.setFieldsValue({ allItem: newItems });
    };

    return (
        <DragDropContext onDragEnd={onDragPersonalEnd}>
            <Droppable droppableId="droppable">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        {allItem?.map((e, i) => {
                            return (
                                <Draggable
                                    draggableId={e?.groupId}
                                    index={i}
                                    key={e?.groupId}
                                >
                                    {(provided) => (
                                        <div
                                            className="bg-[#F4F6FC] p-3 rounded-lg mb-4 relative flex items-center"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <div className="flex items-center mr-4">
                                                <svg
                                                    width="24"
                                                    height="25"
                                                    viewBox="0 0 24 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        y="0.5"
                                                        width="24"
                                                        height="24"
                                                        rx="3"
                                                        fill="#EEE5FF"
                                                    />
                                                    <g clipPath="url(#clip0_2799_251928)">
                                                        <path
                                                            d="M17.3333 10.5H6.66666V11.8333H17.3333V10.5ZM6.66666 14.5H17.3333V13.1667H6.66666V14.5Z"
                                                            fill="#7B67FB"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_2799_251928">
                                                            <rect
                                                                width="16"
                                                                height="16"
                                                                fill="white"
                                                                transform="translate(4 4.5)"
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            <div>
                                                <div className="text-tiny font-base">
                                                    {lang === 'th'  ? e?.nameTh : e?.nameEn}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            );
                        })}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default ListSequent;
